import React from 'react'

import styled from 'styled-components'

import i18n from 'live/services/i18n'

export const NoViewPermission = (): JSX.Element => {
    return (
        <NoViewPermissionContainer>
            <NoViewPermissionContent>
                <i className="fal fa-exclamation-circle" />
                <span className="no-permission-title">{i18n('Permission Required')}</span>
                <span className="description">{i18n("You don't have the necessary permissions")}</span>
            </NoViewPermissionContent>
        </NoViewPermissionContainer>
    )
}

const NoViewPermissionContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    height: 100%;
`

const NoViewPermissionContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    .fa-exclamation-circle {
        font-size: 64px;
        color: var(--yellow-700);
    }

    .no-permission-title {
        font-size: 16px;
        font-weight: 700;

        margin: 24px 0 8px;
    }

    .description {
        max-width: 300px;
        align-self: center;
        color: var(--gray-700);
    }
`
